<template>
	<v-flex>

		<v-dialog
			v-model="attachments"
			width="900"
			ref="dialgFile"
		>

			<v-card>
				<v-card-title class="headline primary white--text">
					Arquivos Em anexo
				</v-card-title>
				<v-card-text>
					<filesdocument v-if="item.attachments.length !== 0 " :filesrcs="item.attachments"  ></filesdocument>
					<span v-else>Não há Arquivos anexados!</span>
				</v-card-text>


			</v-card>

		</v-dialog>
		<v-row dense>
			<v-col class="pa-3">
				<v-card
					:class="documentCurrent.id === item.id ? 'elevation-4' : ''"
					:style="documentCurrent.id === item.id ? {border:'3px solid #F3843C'} :{}"
				height="100%"
				width="100%"
				>
					<v-card-title  >
						<v-col class="pa-0">
								<v-row no-gutters  >
									<v-col  class="pa-0"   cols="8">
										<v-row no-gutters>
												<span class=" text-caption grey--text">Despacho {{number +1}} : {{item.subject}}  |  {{item.receivers[0] ?  item.receivers[0].receiver_category.name  :'null'}}: {{item.created_at | correctDatePt_br}} </span>
										</v-row>
									</v-col>
									<v-col cols="2">

									</v-col>
									<v-col  class="pa-0"  cols="2">
									<v-row  no-gutters>
										<v-col class="pa-0">
											<v-row no-gutters align="start">
													<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																	<v-icon v-bind="attrs" v-on="on" color="primary">mdi-draw</v-icon>
																	<span class="text-caption primary--text ml-1">{{countersignUser}}</span>
															</template>
															<span>Assinaturas</span>
													</v-tooltip>
											</v-row>
										</v-col>
										<v-col class="pa-0">
											<v-row no-gutters align="start">
													<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																	<v-icon v-bind="attrs" v-on="on" color="primary">mdi-eye-outline</v-icon>
																	<span class="text-caption primary--text ml-1">{{item.totalViews === '' ? 0 : item.totalViews   }}</span>
															</template>
															<span>Visualizações</span>
													</v-tooltip>
											</v-row>
										</v-col>
										<v-col class="pa-0">
											<v-row no-gutters align="start">
													<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																	<v-icon v-bind="attrs" @click="attachments = !attachments" v-on="on" color="primary">mdi-paperclip</v-icon>
																	<span class="text-caption primary--text ml-1">{{item.attachments.length}}</span>
															</template>
															<span>Anexos</span>
													</v-tooltip>
											</v-row>

										</v-col>

										</v-row>
									</v-col>
								</v-row>
						</v-col>
					</v-card-title>
				<v-card-text>

							<v-row  >
								<v-col  class="pt-0"  cols="4">
									<v-row no-gutters justify="start">
										<v-card
												width="300"
												elevation="0"
												outlined
												class="teste"
												style="border-radius: 6px"
										>
											<v-list class="pa-0" dense>
												<v-list-item class="pl-1" dense  >
													<v-list-item-icon class="ml-0 mr-3">
															<v-avatar v-if="item.user.avatar"   size="30" >
																	<v-img  :src="item.user.avatar" :alt="item.user.name" />
															</v-avatar>
															<v-avatar v-else color="primary"  size="30" >
																	<span class="white--text text-h6">{{ item.user.name.substring(0,1) }}</span>
															</v-avatar>

													</v-list-item-icon>
													<v-list-item-content >
														<v-list-item-title class="text-subtitle-1 font-weight-bold ">{{item.receivers | userFrom}}</v-list-item-title>
														<v-list-item-subtitle class="text-caption" >{{ item.receivers | userFromPosition}}</v-list-item-subtitle>
													</v-list-item-content>
												</v-list-item>
											</v-list>
										</v-card>
									</v-row>
									<v-row no-gutters class="mt-2">
										<v-col>
											<v-row no-gutters>
													<span class="text-caption"><strong>De</strong> :  <strong>{{item.receivers | entityFrom}}</strong></span>
											</v-row>
											<v-row no-gutters>
													<span class="text-caption"><strong>Para</strong> : <strong>{{item.receivers | entityTo}}</strong></span>
											</v-row>
										</v-col>
									</v-row>
								</v-col>
								<v-col    class="pt-0"  cols="8">
									<v-row no-gutters  >
										<v-card
												elevation="2"
												class="teste"
												style="border-radius: 6px"
												width="100%"
										>

											<v-card-title class=" pa-2" >
												<span class="text-title text-caption"><strong>{{item.subject}}</strong></span>
												<v-spacer></v-spacer>
												<v-btn   @click="expand = !expand" icon>
													<v-icon  color="primary">{{expand ? 'mdi-minus-circle-outline' :  'mdi-plus-circle-outline'}}</v-icon>
												</v-btn>

											</v-card-title>
											<v-card-text class=" text-caption text-justify">
												<v-expand-transition mode="in" >
													<span v-if="expand === false"  v-html="item.content.slice(0,100)+'...'"></span>
													<v-card elevation="0" v-else >
														<span v-html="item.content.slice(0,item.content.length)" ></span>
													</v-card>

												</v-expand-transition>

											</v-card-text>
											<v-card-actions class="justify-end">

												<span class="text-caption grey--text">{{item.created_at | correctDatePt_br}}</span>
											</v-card-actions>
										</v-card>
									</v-row>
								</v-col>
							</v-row>
				</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-flex>
</template>

<script>
 import FilesInDocument from "./FilesInDocument";

 export default {
  name: "DocumentHistoryShow",
 components: {'filesdocument':FilesInDocument},
 props:{
    item:{
      type:Object
    },
  documentCurrent:{
     type:Object
  },
				number:{
      type:Number
				}
		},
  data:()=>({
    expand:false,
    countersignUser:0,
    countersignUsereye:0,
   attachments:false,
    files:[],
  }),
  computed:{
    position:function () {

      let position = this.item.user.entities.filter((e)=>{
        return e.id === this.item.entity.id
      })

		    return position[0].position_pivot.position[0].name
    }
		},

}
</script>

<style scoped>

</style>